export default __webpack_public_path__ + "static/media/Target Bar.90bafe78.svg";